<div
  class="card-body"
  *ngIf="config && config.tipos_eventos_slider && config.tipos_eventos_slider.eventosApp && config.tipos_eventos_slider.eventosApp.length > 0"
>
  <div
    *ngIf="config.mostrar_titulo == 1"
    class="card-title"
    [ngStyle]="{'color': getFontColor()}"
  >
    {{config.tipos_eventos_slider.nome}}
  </div>

  <swiper-container
    #swiperElement class="mySwiper swiper-container"
    slides-per-view="auto"
    [attr.slides-per-view]="(config.tipo_layout == 1 || config.tipo_layout == 2) ? '1.2' : 'auto'"
    autoplay-delay="{{config.idCategoriaEvento == '-1' && eventoList.length > 1 ? '3000' : 'false'}}"
    autoplay-disable-on-interaction="false"
    space-between="10"
    pagination="false"
  >
    <swiper-slide
      class="slide"
      *ngFor="let evento of eventoList"
      (click)="abrirEvento(evento)"
    >
      <div class="slide-content">
        <img [src]="evento.imagem | image:'evento'" />

        <div
          class="slider-infos"
          [ngStyle]="{'color': getFontColor()}"
          *ngIf="config.tipo_layout == 1"
        >
          <h6 class="m-0 titulo">{{evento.tituloDivulgacao}}</h6>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide
      *ngIf="maximoEventos && maximoEventos.maximo && config.idCategoriaEvento !== '-1'"
    >
      <div class="swiper-slide-full" (click)="abrirCategoria()">
        <div class="ver-todos" [ngStyle]="{'color': getFontColor()}">
          <div class="ver-todos-icon">
            <i class="fa-duotone fa-thin fa-newspaper icon"></i>
            <span class="ver-todos-span"> {{'VER TODOS' | translate}} </span>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
</div>
